// extracted by mini-css-extract-plugin
export default {"head":"AuthHeading_head__RBvFy","svgLogo":"AuthHeading_svgLogo__l-zwN"};